import { createContext, useContext } from 'react';
import type { AmbossMode } from './amboss.config';
import type { AmbossHistoryEntry, AmbossHistoryGroup } from './useAmbossHistory';

export type AmbossScreen = 'closed' | 'search' | 'embedded';
export type AmbossOverlay = 'none' | 'help' | 'history';

export interface AmbossContextValue {
  screen: AmbossScreen;
  overlay: AmbossOverlay;
  query: string;
  mode: AmbossMode;
  embedUrl: string | null;
  submissionId: number;
  historyGroups: AmbossHistoryGroup[];
  isOpen: boolean;
  isAmbossMode: boolean;
  open: () => void;
  submit: (query: string, mode: AmbossMode) => void;
  back: () => void;
  showHelp: () => void;
  showHistory: () => void;
  hideOverlay: () => void;
  rerun: (entry: AmbossHistoryEntry) => void;
  deleteEntry: (id: string) => void;
  reportCid: (cid: string) => void;
  close: () => void;
}

export const AmbossContext = createContext<AmbossContextValue | null>(null);

export function useAmboss(): AmbossContextValue {
  const ctx = useContext(AmbossContext);
  if (!ctx) throw new Error('useAmboss must be used within an AmbossProvider');
  return ctx;
}
